import React, { useContext, useEffect } from 'react'
import styled, { css } from 'styled-components'
import media from 'css-in-js-media'

import Container from './Container'

import Section from './Section'
import SlideshowSlider from './SlideshowSlider'
import LayoutContext from './LayoutContext'
import SlideshowScroll from './SlideshowScroll'

const FullWidthLayout = css`
    margin: 0;

    ${Container} {
        padding-left: 0;
        padding-right: 0;
    }
`

export const SlideshowSection = styled(Section)`
    ${(props) => props.fullWidth && FullWidthLayout}

    ${Container} {
        ${media('<desktop')} {
            padding-left: 0;
            padding-right: 0;
        }
    }

    .swiper-slide {
        max-height: 85vh;
    }
`

const Slideshow = ({ data, fullWidth }) => {
    const { isSlideshow, setSlideshow } = useContext(LayoutContext)
    const { id, slideshowImages } = data

    useEffect(() => {
        if (isSlideshow.filter((e) => e.id === id).length == 0) {
            setSlideshow((isSlideshow) => [...isSlideshow, { id: id, data }])
        }
    }, [])

    return (
        <>
            <SlideshowSection fullWidth={fullWidth}>
                    {data.style == 'Small multi image slideshow' ? (
                        <SlideshowScroll data={data} />
                    ) : (
                        <Container>
                            <SlideshowSlider data={data} />
                        </Container>
                    )}
            </SlideshowSection>
        </>
    )
}

export default Slideshow
